<template>
  <div class="work-order-detail">
    <el-row :gutter="20">
      <el-col :span="12">
        <work-order-status-info
          :work-order="wkDetailInfo"
        ></work-order-status-info>
        <work-order-base-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-base-info>
        <work-order-apply-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-apply-info>
        <work-order-user-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-user-info>
        <work-order-more-info
          :work-order="wkDetailInfo"
          label-width="110px"
          @refresh="getWkOrderInfo"
        ></work-order-more-info>
      </el-col>
      <el-col :span="12">
        <work-order-card :isShowHeader="false">
          <work-order-tool
            slot="card-body"
            :work-order="wkDetailInfo"
            @refresh="getWkOrderInfo"
          ></work-order-tool>
        </work-order-card>
        <el-card style="margin-bottom: 10px">
          <el-tabs v-model="isActive">
            <el-tab-pane label="回复" name="reply" v-if="!isCloseStatus">
              <div v-if="!isCloseStatus">
                <work-order-editor
                  ref="workOrder"
                  :configAttachmentsExpDate="true"
                ></work-order-editor>
                <div style="text-align: center">
                  <el-button
                    :loading="replayLoading"
                    :disabled="isCloseStatus"
                    @click="dealWorkOrderByIdNew()"
                    size="small"
                    type="primary"
                  >
                    回复
                  </el-button>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane
              label="转接"
              name="transfer"
              v-if="!isCloseStatus && !isWaitForFeedStatus"
            >
              <work-order-transfer
                :work-order="wkDetailInfo"
                @change="getWkOrderInfo"
              ></work-order-transfer>
            </el-tab-pane>
            <el-tab-pane label="标签" name="tag">
              <work-order-tag-info
                :work-order="wkDetailInfo"
                @change="getWkOrderInfo(1)"
              ></work-order-tag-info>
            </el-tab-pane>
          </el-tabs>
        </el-card>
        <el-card style="margin-bottom: 10px">
          <work-order-process :work-order="wkDetailInfo"></work-order-process>
        </el-card>
      </el-col>
    </el-row>
    <temp-dialog></temp-dialog>
  </div>
</template>

<script>
import api from "plus/api";

export default {
  name: "workmange.workOrderList.workOrderDetail",
  components: {},
  data() {
    return {
      isActive: "reply",
      wkDetailInfo: {},
      replayLoading: false,
    };
  },
  computed: {
    wkOrderId() {
      return this.$route.query.wkOrderId;
    },
    id() {
      return this.$route.query.id;
    },
    workOrder() {
      return this.wkDetailInfo;
    },
    //待处理
    isAcceptStatus() {
      return this.workOrder && this.workOrder.status === 0;
    },
    //已处理
    isWaitForFeedStatus() {
      return this.workOrder && this.workOrder.status === 1;
    },
    //已关闭
    isCloseStatus() {
      return this.workOrder && this.workOrder.status === 2;
    },
    //处理中
    isProcessingStatus() {
      return this.workOrder && this.workOrder.status === 4;
    },
    userType() {
      const userType = new Map([
        ["work.myAccept.detail", "ACCEPTOR"],
        ["work.mySubmit.detail", "AUTHOR"],
        ["workmange.workQuality.detail", "MANAGER"],
        ["workmange.workOrderList.detail", "MANAGER"],
      ]);
      return userType.get(this.$route.name);
    },
  },
  activated() {
    this.getWkOrderInfo();
  },
  deactivated() {
    this.resetData();
  },
  methods: {
    resetData() {
      this.wkDetailInfo = {};
    },
    getWkOrderInfo(type) {
      return api.work.getWorkDetail({ id: this.id }).then((res) => {
        const data = res.data.data;
        this.wkDetailInfo = data;
        //关闭驳回状态
        if (this.wkDetailInfo.status === 2 || this.wkDetailInfo.status === 3) {
          this.isActive = "tag";
        } else {
          this.isActive = "reply";
        }
        if (type == 1) this.isActive = "tag";
      });
    },
    closeWork() {
      this.$confirm("是否解决了您的问题", "关闭工单", {
        confirmButtonText: "解决了",
        confirmButtonClass: "confirmBtn",
        cancelButtonText: "未解决",
        type: "warning",
      })
        .then(() => {
          api.work
            .closeWork({
              wkOrderId: this.wkOrderId,
              optUserType: "MANAGER",
            })
            .then((res) => {
              this.getWkOrderInfo();
            });
        })
        .catch((err) => {});
    },
    dealWorkOrderByIdNew() {
      this.replayLoading = true;
      try {
        const editorData = this.$refs.workOrder.getData();
        const tempPara = {
          workOrderId: this.wkOrderId,
          optUserType: this.userType,
          ...editorData,
        };
        if (!editorData.remark) {
          this.$message.warning("请填写反馈信息！");
        } else {
          api.work
            .replyWorkOrder(tempPara)
            .then((res) => {
              if (res.data.success) {
                this.$message.success("操作成功！");
                this.getWkOrderInfo();
                this.$refs.workOrder.clearData();
              }
            })
            .catch((err) => {});
        }
      } finally {
        this.replayLoading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.work-order-detail {
  width: 100%;

  .detail-header {
    width: 100%;
    background: #fff;
  }

  .transfer-info {
    padding-bottom: 28px;

    .transfer-container {
      padding-left: 19px;

      .transfer-item {
        margin: 20px 0;
        height: 22px;
        line-height: 22px;
        font-size: 16px;

        &:last-child {
          margin-bottom: 0;
        }

        .transfer-item-text {
          margin-right: 10px;
        }

        /*.color-green {
margin-right: 5px;
}

.color-blue {
margin-right: 10px;
}*/
      }
    }
  }

  .record {
    width: 100%;

    .record-container {
      padding-left: 16px;
      box-sizing: border-box;
    }
  }

  .transfer-way {
    padding-bottom: 84px;

    .transfer-form {
      padding-top: 20px;
      border-top: 1px solid #e2e2e2;

      .el-textarea {
        width: 540px;

        /deep/ .el-textarea__inner {
          padding-bottom: 20px !important;
        }

        /deep/ .el-input__count {
          line-height: normal !important;
          right: 20px;
        }
      }

      .el-button {
        width: 104px;
        height: 36px;
        font-size: 14px;
      }
    }
  }
}
</style>
